import { SpaceGroupsFilter } from "@/react/components/shared/MemberFilters/SharedFilters/SpaceGroupsFilter/SpaceGroupsFilter";

interface SpaceGroupFilterProps {
  onChange: (value: string) => void;
  value: string;
}

export const SpaceGroupFilter = ({
  value,
  onChange,
}: SpaceGroupFilterProps) => (
  <SpaceGroupsFilter
    localeNamespace="community_bot.bot_builder.knowledge_page.filters.space_groups"
    isInitialOpen={false}
    onApply={onChange}
    changeUrl={false}
    value={value}
    shouldShowRemoveButton
  />
);
